import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    // Check both Auth0 SDK state AND our manual session state in localStorage
    const localIsAuthenticated = localStorage.getItem("isAuthenticated") === "true";
    
    if (authService.isAuthenticated || localIsAuthenticated) {
      return next();
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    return next(false);
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }

    return next(false);
  });
};
